"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnconfirmedPage = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_1 = require("react-router");
const UnconfirmedPage = () => {
    const { t } = (0, react_i18next_1.useTranslation)('auth');
    return (react_1.default.createElement("div", { className: "apptr__form apptr__form-auth apptr__form__label-standalone" },
        react_1.default.createElement("p", { className: "apptr__form__label-standalone" }, t('auth:UnconfirmedUser')),
        react_1.default.createElement("p", { className: "apptr__form__label-standalone" },
            react_1.default.createElement(react_router_1.Link, { to: "/login" }, t('auth:BackToLoginPage')))));
};
exports.UnconfirmedPage = UnconfirmedPage;
exports.default = exports.UnconfirmedPage;
//# sourceMappingURL=UnconfirmedPage.js.map